export default "__VITE_ASSET__Bp06S47Q__"